export default __webpack_public_path__ + "static/media/fishes.f10b5e3f.svg";